export default function LoadingSpinner() {
  return (
    <div className="loading-container">
      <div className="logo-spinner-wrapper">
        {/* Multiple rotating rings */}
        {/* <div className="spinner-ring ring-1"></div> */}
        <div className="spinner-ring ring-2"></div>
        <div className="spinner-ring ring-3"></div>
        
        {/* Main logo with rotation and pulse */}
        <img 
          src="/static/logo.png" 
          alt="Loading" 
          className="logo-spinner logo-main"
        />
        
        {/* Orbiting mini logos */}
        <div className="orbit-container">
          <img src="/static/logo.png" alt="" className="orbit-logo orbit-1" />
          <img src="/static/logo.png" alt="" className="orbit-logo orbit-2" />
          <img src="/static/logo.png" alt="" className="orbit-logo orbit-3" />
          <img src="/static/logo.png" alt="" className="orbit-logo orbit-4" />
        </div>
      </div>
      <p className="loading-text">Analyzing token data...</p>
    </div>
  );
}
